(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  function applyFooterMobileMenuHeadingStyles() {
    var isMobile = window.matchMedia('(max-width: 767.98px)').matches;
    var headings = document.querySelectorAll('.footer-menu-heading-mobile');

    headings.forEach(function(el) {
      if (isMobile) {
        var fontSize = el.getAttribute('data-mobile-font-size') || '20px';
        var lineHeight = el.getAttribute('data-mobile-line-height') || '1.3';

        el.style.setProperty('font-size', fontSize, 'important');
        el.style.setProperty('line-height', lineHeight, 'important');
      } else {
        el.style.removeProperty('font-size');
        el.style.removeProperty('line-height');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', applyFooterMobileMenuHeadingStyles);
  window.addEventListener('load', applyFooterMobileMenuHeadingStyles);
  window.addEventListener('resize', applyFooterMobileMenuHeadingStyles);
  document.addEventListener('shopify:section:load', applyFooterMobileMenuHeadingStyles);
  document.addEventListener('shopify:section:select', applyFooterMobileMenuHeadingStyles);
  document.addEventListener('shopify:block:select', applyFooterMobileMenuHeadingStyles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
function initKiwiRelatedProducts() {
  if (!window.ks || typeof window.ks.loadSizing !== 'function') {
    setTimeout(initKiwiRelatedProducts, 500);
    return;
  }

  document.querySelectorAll('.kiwi-entry-anchor--related').forEach(function(chartEntry) {
    if (!chartEntry || !chartEntry.id) return;
    if (chartEntry.dataset.kiwiInited === '1') return;
    chartEntry.dataset.kiwiInited = '1';

    var chartId = chartEntry.id;
    var calcId = chartId.replace('kiwi-entry-chart-', 'kiwi-entry-calculator-');

    var productID = chartEntry.dataset.kiwiProductId;
    if (!productID) return;

    var tags = [];
    try { tags = JSON.parse(chartEntry.dataset.kiwiProductTags || '[]'); } catch (e) { tags = []; }

    var categories = [];
    if (chartEntry.dataset.kiwiProductType) categories = [chartEntry.dataset.kiwiProductType];

    var images = [];
    if (chartEntry.dataset.kiwiProductImage) images = [chartEntry.dataset.kiwiProductImage];

    window.ks.loadSizing({
      productData: {
        productID: String(productID),
        sku: chartEntry.dataset.kiwiProductSku || '',
        title: chartEntry.dataset.kiwiProductTitle || '',
        tags: tags,
        categories: categories,
        brand: chartEntry.dataset.kiwiProductVendor || '',
        images: images
      },
      options: {
        // Size Chart：注入到“chart 目标”（前）
        injectionSelector: '#' + chartId,
        displayMode: 1, // 链接/弹窗风格（更接近你截图）
        buttonText: 'Size Chart',
        injectionOrder: 0,

        // What's my size?：注入到“calculator 目标”（后）
        calculatorInjectionSelector: '#' + calcId,
        calculatorDisplayMode: 1,
        calculatorInjectionOrder: 0
      }
    });
  });
}
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".related-products.related-products--wear-it-with");
    if (productRecommendationsSection === null) { return; }

    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var inner = container.querySelector(".related-products.related-products--wear-it-with");
        if (inner) {
productRecommendationsSection.innerHTML = inner.innerHTML;
if (typeof initWearItWithOptions === 'function') initWearItWithOptions();
initKiwiRelatedProducts();
        }
      }
    };
    request.send();
  };

  var productCache = {};

  function getProductJson(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root.replace(/\/$/, '') : '';
    var url = root + '/products/' + encodeURIComponent(handle) + '.js';
    return fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(product) {
        productCache[handle] = product;
        return product;
      });
  }

  function findVariantByOptions(product, selectedOpts) {
    if (!product || !product.variants) return null;
    return product.variants.find(function(v) {
      for (var i = 0; i < v.options.length; i++) {
        var opt = selectedOpts[i];
        if (opt != null && String(v.options[i]).toLowerCase() !== String(opt).toLowerCase()) {
          return false;
        }
      }
      return true;
    });
  }

  function updateVariantAndForm(itemEl, variant, product) {
    if (!variant) return;
    itemEl.querySelectorAll('.wear-it-with-item__form input[name="id"]').forEach(function (input) {
      input.value = variant.id;
    });

    var priceEl = itemEl.querySelector('.wear-it-with-item__price');
    if (priceEl && window.theme && window.theme.formatMoney) {
      var priceSpan = priceEl.querySelector('.price__current .js-value');
      if (priceSpan) priceSpan.textContent = theme.formatMoney(variant.price);

      var compareSpan = priceEl.querySelector('.price__was .js-value');
      var priceDiv = priceEl.querySelector('.price');
      if (compareSpan && priceDiv) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareSpan.textContent = theme.formatMoney(variant.compare_at_price);
          priceDiv.classList.add('price--on-sale');
          priceDiv.classList.remove('price--sold-out');
        } else {
          priceDiv.classList.remove('price--on-sale');
        }
      }
      if (priceDiv) {
        priceDiv.classList.toggle('price--sold-out', !variant.available);
      }
    }

    updateWearItWithItemImage(itemEl, variant, product);
  }

    function updateWearItWithItemImage(itemEl, variant, product) {
    var wrap = itemEl.querySelector('.wear-it-with-item__image');
    if (!wrap) return;
    var img = wrap.querySelector('img');
    if (!img) return;

    var src = null;
    var alt = '';

    if (variant && variant.featured_image && variant.featured_image.src) {
      src = variant.featured_image.src;
      alt = (variant.featured_image.alt != null && variant.featured_image.alt !== '') ? variant.featured_image.alt : '';
    } else if (product) {
      if (product.featured_image) {
        src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
      } else if (product.image) {
        src = typeof product.image === 'string' ? product.image : product.image.src;
      }
      if (product.featured_image && typeof product.featured_image === 'object' && product.featured_image.alt) {
        alt = product.featured_image.alt;
      }
    }

    if (!src) return;

    img.src = src;
    if (alt !== '') img.alt = alt;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    /* 与移动端 CSS 一致：变体图 URL 常不带 Liquid 裁切参数，靠浏览器侧锚定顶部 */
    img.style.setProperty('object-fit', 'cover', 'important');
    img.style.setProperty('object-position', 'top center', 'important');
  }

  function handleOptionClick(evt) {
    var colorItem = evt.target.closest('.product-block-options__item');
    var sizeBtn = evt.target.closest('.wear-it-with-size');
    if (!colorItem && !sizeBtn) return;

    var itemEl = (colorItem || sizeBtn).closest('.wear-it-with-item');
    if (!itemEl) return;

    var handle = itemEl.dataset.productHandle;
    if (!handle) return;

    if (colorItem) {
      if (colorItem.classList.contains('product-block-options__item--unavailable')) return;
      evt.preventDefault();
      var colorContainer = colorItem.closest('.product-block-options');
      // Color 与 Limited Edition 两行共用同一 data-option-position，必须整块互斥，
      // 否则下面行仍残留 --selected，后面 forEach 会覆盖上面行的选择，图片/变体不更新。
      var optPos = colorContainer.getAttribute('data-option-position');
      if (optPos) {
        itemEl.querySelectorAll('.product-block-options[data-option-position]').forEach(function(optEl) {
          if (optEl.getAttribute('data-option-position') !== optPos) return;
          optEl.querySelectorAll('.product-block-options__item').forEach(function(el) {
            el.classList.remove('product-block-options__item--selected');
          });
        });
      } else {
        colorContainer.querySelectorAll('.product-block-options__item').forEach(function(el) {
          el.classList.toggle('product-block-options__item--selected', el === colorItem);
        });
      }
      if (optPos) {
        colorItem.classList.add('product-block-options__item--selected');
      }
      var cg = colorItem.dataset.colorGroup || '';
      var txt = colorItem.dataset.optionItem || '';
      var colorGroupVal = itemEl.querySelector('.js-color-group-value');
      var limitedGroupVal = itemEl.querySelector('.js-limited-group-value');
      if (colorGroupVal) colorGroupVal.textContent = cg === 'limited' ? '' : txt;
      if (limitedGroupVal) limitedGroupVal.textContent = cg === 'limited' ? txt : '';
      var legacyLabel = itemEl.querySelector('.wear-it-with-item__option-label-value');
      if (legacyLabel) legacyLabel.textContent = txt;
    }

    if (sizeBtn) {
      if (sizeBtn.classList.contains('wear-it-with-size--unavailable')) return;
      evt.preventDefault();
      var sizesContainer = sizeBtn.closest('.wear-it-with-item__sizes');
      if (sizesContainer) {
        sizesContainer.querySelectorAll('.wear-it-with-size').forEach(function(el) {
          el.classList.toggle('wear-it-with-size--selected', el === sizeBtn);
        });
      }
    }

    var selectedOpts = [];
    itemEl.querySelectorAll('.product-block-options[data-option-position]').forEach(function(opt) {
      var p = parseInt(opt.dataset.optionPosition, 10);
      if (isNaN(p)) return;
      var sel = opt.querySelector('.product-block-options__item--selected');
      if (sel) selectedOpts[p - 1] = sel.dataset.optionItem;
    });
    itemEl.querySelectorAll('.wear-it-with-item__sizes .wear-it-with-size').forEach(function(btn) {
      var p = parseInt(btn.dataset.optionPosition, 10);
      if (isNaN(p)) return;
      if (btn.classList.contains('wear-it-with-size--selected')) {
        selectedOpts[p - 1] = btn.dataset.optionValue;
      }
    });

    getProductJson(handle).then(function(product) {
      var variant = findVariantByOptions(product, selectedOpts);
      updateVariantAndForm(itemEl, variant, product);
    });
  }

  function handleAddToBagSubmit(evt) {
    var form = evt.target.closest('form');
    if (!form || !form.closest('.related-products--wear-it-with') || !form.closest('.wear-it-with-item')) return;

    evt.preventDefault();

    var submitter = evt.submitter;
    var desktopBtn = form.querySelector('.wear-it-with-item__btn');
    var plusBtn = form.querySelector('.wear-it-with-item__plus-btn');
    var loadingBtn = submitter || desktopBtn || plusBtn;
    var openFromBtn = loadingBtn;
    if (loadingBtn) {
      loadingBtn.disabled = true;
      loadingBtn.classList.add('is-loading');
    }

    var formData = new FormData(form);
    if (!formData.has('quantity')) formData.append('quantity', '1');

    var sectionsToUpdate = ['page-header', 'cart-drawer'].map(function (sel) {
      return document.querySelector(sel);
    }).filter(function (el) {
      return el && el.dataset && el.dataset.sectionId;
    });
    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sectionsToUpdate.map(function (el) {
      return el.dataset.sectionId;
    }).join(','));

    var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { res: res, data: data };
        });
      })
      .then(function (result) {
        var res = result.res;
        var data = result.data;
        var error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.keys(data.errors).map(function (k) {
            return data.errors[k];
          }).join(', ');
        }
        if (!res.ok) {
          throw new Error(error || ('HTTP ' + res.status));
        }
        if (data.errors && typeof data.errors === 'object' && Object.keys(data.errors).length) {
          throw new Error(error || 'Add to cart failed');
        }

        if (document.querySelector('.template-cart')) {
          var cartFormEl = document.querySelector('cart-form');
          if (cartFormEl && cartFormEl.enableAjaxUpdate) {
            cartFormEl.refresh();
          }
        } else if (window.theme && theme.settings.afterAddToCart === 'page') {
          setTimeout(function () {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
            sectionsToUpdate.forEach(function (el) {
              el.updateFromCartChange(data.sections[el.dataset.sectionId]);
            });
          } else {
            document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
          }

          if (window.theme && theme.settings.afterAddToCart === 'notification') {
            var tpl = document.getElementById('AddedNotification');
            if (tpl && tpl.content && tpl.content.firstElementChild) {
              var notification = tpl.content.firstElementChild.cloneNode(true);
              notification.dataset.productTitle = data.product_title || '';
              var notificationContainer = document.querySelector('.pageheader--sticky') || document.querySelector('body');
              notificationContainer.appendChild(notification);
            }
          } else if (window.theme && theme.settings.afterAddToCart === 'drawer') {
            var drawer = document.querySelector('.js-cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open(openFromBtn);
            }
          }
        }

        document.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantId: data.variant_id }
        }));

        if (loadingBtn) {
          loadingBtn.classList.add('is-success');
          setTimeout(function () {
            loadingBtn.classList.remove('is-loading', 'is-success');
            loadingBtn.disabled = false;
          }, 2000);
        }
      })
      .catch(function (err) {
        var item = form.closest('.wear-it-with-item');
        if (item) {
          item.querySelectorAll('.wear-it-with-item__btn, .wear-it-with-item__plus-btn').forEach(function (b) {
            b.classList.remove('is-loading', 'is-success');
            b.disabled = false;
          });
        } else if (loadingBtn) {
          loadingBtn.classList.remove('is-loading', 'is-success');
          loadingBtn.disabled = false;
        }
        document.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: err && err.message ? err.message : 'Add to cart failed' }
        }));
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
      });
  }

  function initWearItWithOptions() {
    var section = document.querySelector('.related-products.related-products--wear-it-with');
    if (!section) return;
    section.removeEventListener('click', handleOptionClick);
    section.addEventListener('click', handleOptionClick);
    section.removeEventListener('submit', handleAddToBagSubmit);
    section.addEventListener('submit', handleAddToBagSubmit);
  }

  document.addEventListener('DOMContentLoaded', initWearItWithOptions);
  document.addEventListener('shopify:section:load', function(evt) {
    if (document.querySelector('[data-section-id="' + evt.detail.sectionId + '"].related-products--wear-it-with')) {
      setTimeout(initWearItWithOptions, 100);
    }
  });

  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products--wear-it-with')) {
      loadProductRecommendationsIntoSection();
    }
  });

loadProductRecommendationsIntoSection();
initKiwiRelatedProducts();

  } catch(e) { console.error(e); }
})();
})();
